export default __webpack_public_path__ + "static/media/Girdle of the Invincible.f49ce9aa.jpg";